export default __webpack_public_path__ + "static/media/eng-flag.b508ea5f.svg";